export default __webpack_public_path__ + "static/media/JensenRice_Resume.9501ed72.jpg";